import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconTelevisionOld"><Path d="M6.90802 2.78958C7.16232 2.46262 7.63353 2.40372 7.96049 2.65802L12 5.79989L16.0396 2.65802C16.3665 2.40372 16.8377 2.46262 17.092 2.78958C17.3464 3.11654 17.2875 3.58775 16.9605 3.84205L14.186 6H20.25C21.2165 6 22 6.7835 22 7.75V19.25C22 20.2165 21.2165 21 20.25 21H3.75C2.7835 21 2 20.2165 2 19.25V7.75C2 6.7835 2.7835 6 3.75 6H9.81409L7.03958 3.84205C6.71262 3.58775 6.65372 3.11654 6.90802 2.78958Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevisionOld;
